module.exports = __webpack_public_path__ + "static/landing-img-d-0a5d72973223811c31ad8f5d6f17d7e7.svg";